import { useEffect } from 'react';
import { UnifiedNumberFormat } from '@formatjs/intl-unified-numberformat';
import { LoadType } from 'sharedTypes/loads/loadType';
import { OfferType } from 'sharedTypes/offers/offers';
import { CurrentUserType } from 'sharedTypes/user/userTypes';
UnifiedNumberFormat.__addLocaleData(require('@formatjs/intl-unified-numberformat/dist/locale-data/en.json'));

export const WeightFormat = new UnifiedNumberFormat('en', { style: 'unit', unit: 'pound', unitDisplay: 'short' });
export const GenericFormatter = new UnifiedNumberFormat();
export const DistanceFormatter = new UnifiedNumberFormat('en', { style: 'unit', unit: 'mile', unitDisplay: 'short' });
export const PricingFormatter = new UnifiedNumberFormat('en', { style: 'currency', currency: 'USD', minimumFractionDigits: 0 });
export const FullPriceFormatter = new UnifiedNumberFormat('en', { style: 'currency', currency: 'USD' });
export const CompactFormatter = new UnifiedNumberFormat('en', { notation: 'compact', minimumFractionDigits: 0, maximumFractionDigits: 1 });
export const CompactPriceFormatter = new UnifiedNumberFormat('en', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, notation: 'compact' })

export const testIdHelper = (sourceString: string, baseIdentifier: string) => {
  const newTestId = sourceString ? sourceString.toLowerCase() : '';
  if (newTestId) {
    // Implemented polyfill
    // eslint-disable-next-line
    // @ts-ignore
    return `${baseIdentifier}-${newTestId.replaceAll(' ', '-')}`;
  }
  return newTestId;
}


export const useSetTitle = (title: string) => {
  useEffect(() => {
    if (document?.title !== title) {
      document.title = title;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title])
}

const capitalizeCorrectlyRegex = /(\b[a-z](?!\s))/g
export const capitalizeWord = (word: string) => {
  return (word || '').toLowerCase().replace(capitalizeCorrectlyRegex, letter => letter.toUpperCase());
}

export const reportSuggestedLoadEvent = (title: string, matchId: number, load: LoadType, offer: OfferType, bookAmount: number, currentUser: CurrentUserType, offerAmount?: number) => {
  const payload = {
    MatchId: matchId,
    LoadNumber: load.LoadBoardId,
    OfferId: offer?.id,
    BINPrice: bookAmount,
    CarrierCode: currentUser.CarrierCode,
    CarrierName: currentUser.CarrierName,
    RepCode: currentUser.CarrierRep.KeypointUserCode,
    Name: `${currentUser.FirstName} ${currentUser.LastName}`,
    Email: currentUser.EmailAddress,
    timeStamp: new Date().toISOString(),
    source: window.location.pathname
  }

  if (offerAmount) {
    (payload as any).OfferAmount = offerAmount;
  }
  window.pendo.track(title, payload)
}
